import React from 'react';
import { Form } from 'react-bootstrap';

const InputBuscar = ({
    value,
    onChange,
    placeholder,
    name,
    id,
    type,
    maxLength,
    min,
    max
}) => {
    return (
        <Form.Control
            type={type}
            id={id}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            min={min}
            max={max}
        />
    );
};

export default InputBuscar;
